import script from "./myTeachingLog.vue?vue&type=script&setup=true&lang=js"
export * from "./myTeachingLog.vue?vue&type=script&setup=true&lang=js"

import "./myTeachingLog.vue?vue&type=style&index=0&id=6da16ca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6da16ca6"]])

export default __exports__